import { render, staticRenderFns } from "./min-volume-cell.vue?vue&type=template&id=2d9ba7f6&"
import script from "./min-volume-cell.vue?vue&type=script&lang=ts&"
export * from "./min-volume-cell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports